export default __webpack_public_path__ + "static/media/329.2f81ccb6.png";